import BaseInstitutionEntity from "@/models/Shared/BaseInstitutionEntity";
import InstitutionState from "@/models/Settings/Institutions/InstitutionState";
import Address from '@/models/Customers/Addresses/Address';

export default class Institution extends BaseInstitutionEntity {
    name:  string;
    code:  string;
    defaultCurrency: string;
    portalAppMedium: string;
    fiApiAccess: boolean;
    uxApiAccess: boolean;
    state: InstitutionState;
    address: Address;
    createdAtUtc: Date;
    updatedAtUtc: Date;
}